import { render, staticRenderFns } from "./XuQiuIssue.vue?vue&type=template&id=2aa8fadc&scoped=true&"
import script from "./XuQiuIssue.vue?vue&type=script&lang=js&"
export * from "./XuQiuIssue.vue?vue&type=script&lang=js&"
import style0 from "./XuQiuIssue.vue?vue&type=style&index=0&id=2aa8fadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8fadc",
  null
  
)

export default component.exports